import { memo } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import CertificateDetail from "./DetailSingleDegree";

export const ViewDetailSearchResultModal = memo(({ data, setDegreeInformation }: { data: any | null; setDegreeInformation: Function }) => {
	if (data === null) return <></>;

	return (
		<div>
			<Dialog
				open={data !== null}
				onOpenChange={() => {
					setDegreeInformation(null);
				}}
			>
				<DialogContent className='max-w-6xl'>
					<DialogHeader>
						<DialogTitle style={{ textTransform: "capitalize" }}>Thông Tin Chi Tiết </DialogTitle>
					</DialogHeader>
					<div className='space-y-3 h-[500px] md:h-full overflow-y-scroll md:overflow-visible'>
						<CertificateDetail data={data} />
					</div>
				</DialogContent>
			</Dialog>
		</div>
	);
});
